import { CheckAuth } from './RouteGuard';
import AuthenticationRoutes from './AuthRoutes';

import UserRoutes from './UserRoutes';
import Layout from 'modules/home/Layout';
// import SingleFixPacket from 'modules/home/manage-packets/single-fix-packet/FixPacketPage';
// import SolicitorDocumentViewer from 'modules/home/manage-packets/solicitor-viewer/SolicitorDocumentPage';
// import SingleReviewedPacket from 'modules/home/manage-packets/single-reviewed-packet/SingleReviewPage';
import MainRoute from './MainRoutes';
import UploadReworkPage from 'modules/home/upload-documents/upload-rework/UplodaReworkPage';
import { Navigate } from 'react-router-dom';

import ShareTemplateInvitation from 'modules/home/manage-clients/dashboard/components/ShareTemplateInvitation';

import ShareTemplateConfirmationStatus from 'modules/home/manage-clients/dashboard/components/ShareTemplateConfirmationStatus';

import SingleFixPacket from 'modules/home/manage-packets/single-fix-packet/FixPacketPage';

import NotExpectedPacket from 'modules/home/manage-packets/not-expected-packet/NotExpectedPage';

import SolicitorDocumentViewer from 'modules/home/manage-packets/solicitor-viewer/SolicitorDocumentPage';

import SingleReviewedPacket from 'modules/home/manage-packets/single-reviewed-packet/SingleReviewPage';

import FinishUploadReworkPage from 'modules/home/upload-documents/upload-rework/FinishUploadReworkPage';

import ExpiredUploadReworkPage from 'modules/home/upload-documents/upload-rework/ExpiredUploadReworkPage';

import DesignBook from 'shared/components/DesignBook';

const routes = (isUserLoggedIn: boolean, role: string, id: string): any => [
    {
        path: '',
        element: CheckAuth(isUserLoggedIn, <Layout />),
        children: [
            {
                path: '',
                element: <Navigate to="/dashboard" replace />,
            },
            UserRoutes(),
            ...Array.from(MainRoute()).filter(
                (i: any) =>
                    (((i.path === 'manage-checklists' ||
                        i.path === 'manage-access') &&
                        role === 'operator') ||
                        (i.path === 'manage-checklists' &&
                            role === 'senior')) === false
            ),
            { path: 'single-cross-check', element: <SingleFixPacket /> },
            {
                path: 'not-expected-cross-check',
                element: <NotExpectedPacket />,
            },
            { path: 'single-reviewed', element: <SingleReviewedPacket /> },
            { path: 'loanwriter', element: <SolicitorDocumentViewer /> },
        ],
    },
    AuthenticationRoutes(isUserLoggedIn, id),
    { path: '/style', element: <DesignBook /> },
    { path: '/upload-rework/:packetId/:token', element: <UploadReworkPage /> },
    {
        path: '/expired-upload-rework/:packetId/:token',
        element: <ExpiredUploadReworkPage />,
    },
    {
        path: 'finish-upload-rework',
        element: <FinishUploadReworkPage />,
    },
    {
        path: '/share-template-invite/:templateId/:tokendId',
        element: <ShareTemplateInvitation />,
    },
    {
        path: '/share-template/:status',
        element: <ShareTemplateConfirmationStatus />,
    },
];

export default routes;
